import React, { useEffect } from "react";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import Layout from "./AppLayout";
import { ROUTES } from "./utils/routeUtils";
import { Toaster } from "react-hot-toast";
import LogoutSuccess from "./components/LogoutSuccess";

// ✅ Import your initAuth
import { initAuth } from "./utils/services/axiosInstance";

function App() {
  useEffect(() => {
    const setVh = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };

    setVh();
    window.addEventListener("resize", setVh);
    return () => window.removeEventListener("resize", setVh);
  }, []);

  useEffect(() => {
    // ✅ Initialize auth on app load
    (async () => {
      await initAuth();
    })();
  }, []);

  return (
    <div
      className="app w-full"
      style={{ height: "calc(var(--vh, 1vh) * 100)" }}
    >
      <Toaster />
      <Routes>
        <Route path="/logout-success" element={<LogoutSuccess />} />
        <Route element={<Layout />}>
          {ROUTES.map((route, i) => (
            <Route key={i} path={route.path} element={route.element} />
          ))}
        </Route>
      </Routes>
    </div>
  );
}

export default App;
